// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.logo-container {
  position: relative;
  display: inline-block;
  width: 64px;
  height: 64px;
  overflow: visible;
}

.logo {
  width: 100%;
  height: auto;
  display: block;
}

.logo-text {
  font-weight: 600;
}

.logo-sub-text {
  font-weight: 300;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/structural/logo-container.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".logo-container {\n  position: relative;\n  display: inline-block;\n  width: 64px;\n  height: 64px;\n  overflow: visible;\n}\n\n.logo {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.logo-text {\n  font-weight: 600;\n}\n\n.logo-sub-text {\n  font-weight: 300;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
